<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>


    <Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading"
            size="large"
            type="primary"> 提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from '../components/Date.vue';
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import {initWxConfig} from "../api/jssdk.js";
import {getTemplateInfo, submitProcess} from "@/api/approval";
import {getUserInfos, getRelation, getUserInfo, IsFirstInCompany,IsFirstInCompnayForEmpNos} from "@/api/employee"
import {getDepartmentInfo, getDepartmentRelationByName} from "@/api/department";
import {mentoringRelationshipFill, getApprentice} from '@/api/MentoringRelationship'
import choose from "../components/choose/Choose";
import {isFirstCommercialShop} from "../api/MentoringRelationship";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      receivingEntity: {
        MasterWorker: null,
        Apprentices: []
      },
      Choose: null
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(false);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "multi", // 必填，选择模式，single表示单选，multi表示多选
            type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              var users = res.result.userList;
              if (users.length !== 0) {
                that.templateData.TemplateContent.Controls.forEach(item => {
                  if (item.Property.Title[0].Text === "带教生效日期") {
                    item.IsShow = true
                  }
                })
              } else {
                that.templateData.TemplateContent.Controls.forEach(item => {
                  if (item.Property.Title[0].Text === "带教生效日期") {
                    item.IsShow = false
                  }
                })
              }
              var codes = []
              var names = []
              dataVal.Values = [];
              that.receivingEntity.Apprentices = []
              users.forEach(user => codes.push(user.id))
              if(that.Choose === null)
                that.Choose = []
              var filter = codes.filter(v => that.Choose.includes(v));
              console.log("filter..")
              console.log(filter)
              if (filter.length > 0) {
                setTimeout(() => {
                  that.Message({
                    message: '徒弟不能重复选择',
                    type: 'error',
                    duration: 3000
                  });
                  dataVal.Value = ""
                }, 200)
              } else {
                users.forEach(user => names.push(user.name))
                dataVal.Value = names.join(",");
                that.listLoading = true;
                await getUserInfos(codes).then(async res => {
                  let bodys = res.Body
                  console.log("body...")
                  console.log(bodys)
                  let err = bodys.filter(e => e.EmployeeInfo.JobLevel > 2)
                  if (err.length !== 0) {
                    console.log("err...")
                    let errEmpName = []
                    for (let i = 0; i < err.length; i++) {
                      let data = err[i]
                      errEmpName.push(data.EmployeeInfo.EmpName)
                    }
                    setTimeout(() => {
                      that.Message({
                        message: `${errEmpName.join(",")}职级超过二级，不在选择范围内`,
                        type: 'error',
                        duration: 3000
                      });
                      dataVal.Value = ""
                    }, 200)
                  } else {
                    let flag = true;
                    await isFirstCommercialShop(codes).then(res => {
                      let bodys = res.Body
                      if(!bodys){
                        flag = false
                        setTimeout(() => {
                          that.Message({
                            message: '徒弟没有申请权限(只有首次入职工商铺的人可选择)',
                            type: 'error',
                            duration: 3000
                          });
                          dataVal.Value = ""
                        }, 200)
                      }
                    })
                    if(flag){
                      for (const body of bodys) {
                        let empInfo = body.EmployeeInfo
                        that.receivingEntity.Apprentices.push({
                          EmpNo: empInfo.EmpNo,
                          EmpName: empInfo.EmpName,
                          EntryTime: empInfo.InCompanyDate,
                          Position: empInfo.PositionName
                        })
                        dataVal.Values.push([empInfo.EmpNo, empInfo.EmpName]);
                      }
                    }
                  }
                })
              }
              that.listLoading = false;
            }
          }
      );
    },
    getEmployeeRelation: async function () {
      await getRelation(this.logInfo.EmpNo).then(response => {
        this.relationList = response.Body[0].Nodes;
      });
    },
    Where(arr,callback) {
      console.log("1111111111111")
      let results = []
      for (let i = 0; i < arr.length; i++) {
        console.log("2222222222222")
        let data = arr[i]
        let flag = callback(data)
        if(flag){
          results.push(data)
        }
      }
      return results
    },
    getSelectorVal(val, name) {
    },
    getTextVal() {
    },
    getTemplate: async function () {
      var that = this;
      await that.getEmployeeRelation();
      that.listLoading = true;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const empNo = that.logInfo.EmpNo;
      getApprentice(empNo).then(res => {
        if (res.Body !== null) {
          that.Choose = res.Body
        }
      })
      const inCompanyDate = that.logInfo.InCompanyDate;
      const positionName = that.logInfo.PositionName;
      if (departName.indexOf("营业部/工商铺商业运营中心") === -1 || jobLevel < 3) {
        setTimeout(() => {
          this.Message({
            message: '你暂无申请权限',
            type: 'error',
            duration: 2000
          });
          this.isDisabled = true;
        }, 200)
      }
      this.receivingEntity.MasterWorker = {
        EmpNo: empNo,
        EmpName: empName,
        Position: positionName,
        EntryTime: inCompanyDate
      }
      await getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        var that = this;
        controls.TemplateContent.Controls.forEach(item => {
          if (item.Property.Title[0].Text === "申请人工号") {
            item.Value = that.logInfo.EmpNo
          }
          if (item.Property.Title[0].Text === "申请人名称") {
            item.Value = empName
          }
          if (item.Property.Title[0].Text === "申请部门") {
            item.Value = that.logInfo.DeptName
          }
          if (item.Property.Title[0].Text === "带教生效日期") {
            item.IsShow = false
          }
          if (item.Property.Title[0].Text === "申请人直属上级") {
            item.IsShow = false
            item.Values = []
            for (let i = 0; i < this.relationList.length; i++) {
              const node = this.relationList[i]
              if (node.Items !== null) {
                item.Values.push([node.Items[0].EmpNo, node.Items[0].EmpName])
                break;
              }
            }
          }
        })
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
    },
    submit: async function () {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }
      this.templateData.TemplateContent.Controls.forEach(item => {
        if(item.Property.Title[0].Text === "申请人工号"){
          item.Value = "SC20003197"
        }
      })

      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "带教生效日期") {
          this.receivingEntity.MasterWorker.EffectiveDate = item.Value
        }
      })

      this.isDisabled = true;
      var SummaryList = [];
      var info = {SummaryInfo: []}
      info.SummaryInfo = [];

      var info = {SummaryInfo: []}
      info.SummaryInfo = [];
      info.SummaryInfo.push({"Text": "申请人：" + " " + this.logInfo.EmpName, "Lang": "zh_CN"});
      SummaryList.push(info);
      var info = {SummaryInfo: []}
      info.SummaryInfo = [];
      info.SummaryInfo.push({"Text": "申请部门：" + " " + this.logInfo.DeptName, "Lang": "zh_CN"});
      SummaryList.push(info);
      var info = {SummaryInfo: []}
      var data = new Date();
      var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      info.SummaryInfo = [];
      info.SummaryInfo.push({"Text": "申请时间：" + " " + dateTime, "Lang": "zh_CN"});
      this.receivingEntity.MasterWorker.SubmitTime = dateTime
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList
      // JSON.stringify()
      //提交
      await submitProcess(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          this.templateData
      )
          .then((response) => {
            console.log(response)
            setTimeout(()=>{},500)
            this.receivingEntity.FlowId = response.Body.SpNo
            //保存
            mentoringRelationshipFill(this.receivingEntity);
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 3 * 1000,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 3000);
          })
          .catch(err => {
            this.isDisabled = false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  },
};
</script>

<style scoped>

</style>